const actions = {
  async handleLeaveSpace({dispatch}, spaceId) {
    const callback = async() => {
      let res = await dispatch('api/nav/yieldSpaceAccess', spaceId)
      let data = res?.success
      if(data) {
        dispatch('popups/show/success/custom', 'You left the Space', {root: true})
        dispatch('enterSwitchAreaPageHandler')
        dispatch('analytics/removeSpace', spaceId)
        return data
      } else if (res?.error && res.error.code === "admin_not_alone") {
        dispatch('popups/show/error',{
          message: `You are the only admin in this Space, so you can't leave.<br/><br/>Make someone else an admin or remove them.`
        }, {root: true})
      } else {
        dispatch('popups/show/error/custom', 'leaving this Space', {root: true})
        return false
      }
    }
    dispatch('popups/nav/confirmLeaveArea', callback)
  },
};

export default {
  actions
};
